(function () {
  function initBar(root) {
    const track = root.querySelector("[data-cab-track]");
    const slides = Array.from(root.querySelectorAll("[data-cab-slide]"));
    const prev = root.querySelector("[data-cab-prev]");
    const next = root.querySelector("[data-cab-next]");

    if (!track || slides.length <= 1) {
      if (prev) prev.style.display = "none";
      if (next) next.style.display = "none";
      return;
    }

    // Prevent double init (Theme editor can re-render sections)
    if (root.dataset.cabInited === "true") return;
    root.dataset.cabInited = "true";

    // Clone last at start, clone first at end
    const firstReal = slides[0];
    const lastReal = slides[slides.length - 1];

    const firstClone = firstReal.cloneNode(true);
    const lastClone = lastReal.cloneNode(true);

    firstClone.removeAttribute("data-cab-slide");
    lastClone.removeAttribute("data-cab-slide");
    firstClone.setAttribute("data-cab-clone", "first");
    lastClone.setAttribute("data-cab-clone", "last");

    track.insertBefore(lastClone, track.firstChild);
    track.appendChild(firstClone);

    const totalReal = slides.length;
    let index = 1; // start on first real slide
    let isAnimating = false;

    const setTransition = (on) => {
      track.style.transition = on ? "transform .35s ease" : "none";
    };

    const setButtonsDisabled = (disabled) => {
      if (prev) prev.disabled = disabled;
      if (next) next.disabled = disabled;
    };

    const applyTransform = () => {
      track.style.transform = `translateX(${-index * 100}%)`;
    };

    const snapTo = (newIndex) => {
      setTransition(false);
      index = newIndex;
      applyTransform();
      // force reflow
      track.offsetHeight;
      setTransition(true);
    };

    const go = (newIndex) => {
      if (isAnimating) return;
      isAnimating = true;
      setButtonsDisabled(true);

      index = newIndex;
      applyTransform();
    };

    track.addEventListener("transitionend", (e) => {
      if (e.propertyName !== "transform") return;

      if (index === 0) {
        snapTo(totalReal);
      } else if (index === totalReal + 1) {
        snapTo(1);
      }

      isAnimating = false;
      setButtonsDisabled(false);
    });

    track.addEventListener("transitioncancel", () => {
      isAnimating = false;
      setButtonsDisabled(false);
    });

    next && next.addEventListener("click", () => go(index + 1));
    prev && prev.addEventListener("click", () => go(index - 1));

    // Autoplay from data attributes
    const autoplay = root.getAttribute("data-autoplay") === "true";
    const intervalMs = Number(root.getAttribute("data-interval")) || 5000;

    let timer = null;
    const stop = () => {
      if (timer) clearInterval(timer);
      timer = null;
    };
    const start = () => {
      if (!autoplay) return;
      stop();
      timer = setInterval(() => {
        if (!isAnimating) go(index + 1);
      }, intervalMs);
    };

    root.addEventListener("mouseenter", stop);
    root.addEventListener("mouseleave", start);
    root.addEventListener("focusin", stop);
    root.addEventListener("focusout", start);

    // Init at first real slide
    setTransition(false);
    applyTransform();
    track.offsetHeight;
    setTransition(true);

    start();
  }

  function initAll() {
    document.querySelectorAll("[data-cab]").forEach(initBar);
  }

  // Initial load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  // Shopify Theme Editor support (sections can hot-reload)
  document.addEventListener("shopify:section:load", (e) => {
    const container = e.target;
    if (!container) return;
    container.querySelectorAll("[data-cab]").forEach((el) => {
      el.dataset.cabInited = "false";
      initBar(el);
    });
  });
})();